import { xorBy } from "lodash";
import { useState, MouseEvent } from "react";
import { FilterOption } from "shared/components/Filter";
import { useAnchorEl } from "shared/hooks/useAnchorEl";
import { statusOptions } from "../constants";
import { FilterHook } from "../types";

export const useStatusFilter = (): FilterHook => {
  const [status, setStatus] = useState<FilterOption[]>([]);
  const { open, handleAnchorClose, handleAnchorOpen, anchorEl } = useAnchorEl();

  const handleChangeValue = (
    _: MouseEvent<HTMLElement>,
    option: FilterOption,
  ) => {
    setStatus((prevStatus) => xorBy(prevStatus, [option], "value"));
  };

  const onClearSelectedValues = () => setStatus([]);

  return {
    filteredValues: status.map((item) => item.value) ?? [],
    setFilteredValues: setStatus,
    filterData: {
      options: statusOptions,
      anchorEl,
      open,
      selectedValue: status,
      handleOpenMenu: handleAnchorOpen,
      handleChangeValue,
      handleClose: handleAnchorClose,
      onClearSelectedValues,
    },
  };
};
